import { useEffect, useState } from "react";

export function useBreakpoints(MOBILE_BREAKPOINT = 768, DESKTOP_BREAKPOINT = 1300) {
  const [isMobile, setIsMobile] = useState(undefined);
  const [isDesktop, setIsDesktop] = useState(undefined);

  useEffect(() => {
    const update = () => {
      const width = window.innerWidth;
      setIsMobile(width < MOBILE_BREAKPOINT);
      setIsDesktop(width >= DESKTOP_BREAKPOINT);
    };

    window.addEventListener("resize", update);
    update(); // init

    return () => window.removeEventListener("resize", update);
  }, [MOBILE_BREAKPOINT, DESKTOP_BREAKPOINT]);

  return { isMobile, isDesktop };
}
